import { render } from "./ProductMain.vue?vue&type=template&id=4d0a2ecd&scoped=true"
import script from "./ProductMain.vue?vue&type=script&lang=js"
export * from "./ProductMain.vue?vue&type=script&lang=js"

import "./ProductMain.vue?vue&type=style&index=0&id=4d0a2ecd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0a2ecd"]])

export default __exports__